import React from 'react'
import { ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

interface CardWrapperProps {
  children: ReactNode
  className?: string
  url?: string
}

const CardWrapper: React.FC<CardWrapperProps> = ({
  children,
  className,
  url = null,
}) => <div className={twMerge('relative group', className)}>{children}</div>

export default CardWrapper
